import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { RegistrationApi } from '../../../../shared/Apis/Account/Register/RegistrationApi';
import { RegistrationRequest } from '../../../../shared/Apis/Account/Register/Requests/RegistrationRequest';
import { BasePage } from '../../../../shared/components/base-page.component';
import { PasswordHelper } from '../../../../shared/helpers/PasswordHelper';
import { AccountRegisterPageModel } from './Models/AccountRegisterPageModel';
import { UrlHelper } from '../../../../shared/helpers/UrlHelper';

@Component({
    selector: 'account-register-page',
    standalone: true,
    imports: [...BasePage.BaseImports],
    templateUrl: './AccountRegisterPage.html',
    styleUrl: './AccountRegisterPage.css',
})

export class AccountRegisterPage implements BasePage, OnInit
{
    model$ = new BehaviorSubject<AccountRegisterPageModel | null>(null);
    error$ = new BehaviorSubject<string | null>(null);
    loading$ = new BehaviorSubject(false);
    loginUrl = '';

    constructor(private registrationApi: RegistrationApi, private route: ActivatedRoute, private router: Router)
    {
        const planSlug = this.route.snapshot.paramMap.get('plan');
        const returnUrl = window.location.origin + router.createUrlTree(['/subscribe', planSlug]);
        this.loginUrl = `${UrlHelper.AppBaseUrl}/login?returnUrl=${encodeURIComponent(returnUrl.toString())}`;
    }

    async ngOnInit()
    {
        const model = new AccountRegisterPageModel();
        this.model$.next(model);
    }

    async submit(form: NgForm)
    {
        console.log(form.controls);

        if (form.invalid)
        {
            console.log('invalid form');
            form.control.markAllAsTouched(); // show validation errors
            return;
        }

        const registerRequest: RegistrationRequest = {
            FirstName: this.model$.value!.FirstName!,
            LastName: this.model$.value!.LastName!,
            Email: this.model$.value!.Email!,
            Password: this.model$.value!.Password!,
            AcceptTerms: this.model$.value!.AcceptTerms!
        };

        this.loading$.next(true);
        this.error$.next(null);
        try
        {
            await this.registrationApi.register(registerRequest);

            this.router.navigate(['/account/confirm']);
        }
        catch (err: any)
        {
            this.error$.next(err);
        }
        finally
        {
            this.loading$.next(false);
        }
    }

    validatePassword(password: string | null): string[]
    {
        return PasswordHelper.ValidatePassword(password);
    }
}
